import * as React from 'react';

import { LONG_DATE_ONLY_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { Typography } from '@coursera/cds-core';

import type { S12nCourseCertificate } from 'bundles/accomplishments/components/s12n-certificates/types';
import RecordTile from 'bundles/accomplishments/components/shared/RecordTile';
import { formatInstructorNames, formatPartnerNames } from 'bundles/accomplishments/utils/formatting';
import { getCertificateSharingLink, getCourseCertificateVerifyLink } from 'bundles/accomplishments/utils/routingUtils';

import _t from 'i18n!nls/accomplishments';

import 'css!./__styles__/CourseRecords';

type Props = {
  courseCerts: S12nCourseCertificate[];
  userName: string;
  ownRecord?: boolean;
  isS12nCerts?: boolean;
};

const CourseRecords = (props: Props) => {
  const { courseCerts, userName, ownRecord, isS12nCerts } = props;
  return (
    <div className="course-certificates-section">
      <div className="certificates-container">
        <Typography variant="h2semibold" component="h3">
          {_t('Course Certificates')}
        </Typography>
        {isS12nCerts && <p className="subheading">{_t('Earned after completing each course in the Specialization')}</p>}
        <div className="certificate-records">
          {courseCerts.length > 0 &&
            courseCerts.map((courseCertificate) => {
              return (
                <RecordTile
                  key={courseCertificate.courseName}
                  userName={courseCertificate.userName}
                  courseName={courseCertificate.courseName}
                  universityNames={formatPartnerNames(courseCertificate.partnerNames)}
                  instructorNames={formatInstructorNames(courseCertificate.instructorNames)}
                  certificateLink={getCertificateSharingLink(false, courseCertificate.certificateCode)}
                  recordLink={getCourseCertificateVerifyLink(courseCertificate.certificateCode)}
                  completionDate={`Completed by: ${userName} by ${formatDateTimeDisplay(
                    courseCertificate.certificateGrantDate,
                    LONG_DATE_ONLY_DISPLAY
                  )}`}
                  courseWorkload={courseCertificate.courseWorkload}
                  grade={courseCertificate.certificateGrade} // handles isNaN by rendering "--"
                  ownRecord={ownRecord}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default CourseRecords;
